import {
  AVISO_PLAZO_TRANSMISION_INFORMATIVO,
  calcularPlazoDeTransmision,
  descripcionFechaDelEvento,
  descripcionPlazoDeTransmision,
  fechaDesdeTexto,
} from '../../../utils/plazos-invalidacion.utils'

const AVISO_FECHA_BASE_DEL_PLAZO =
  'El plazo se cuenta desde el sello de recepción del documento; aquí se calcula con la fecha en que usted lo generó.'

const ESTILO_DETALLE = {
  fontSize: '12px',
  color: 'rgba(27, 27, 27, 0.6)',
  display: 'block',
  marginTop: '2px',
}

const ESTILO_VENCIDO = {
  fontSize: '12px',
  color: 'rgba(247, 29, 29, 0.978)',
  display: 'block',
  marginTop: '2px',
}

interface PropsAvisoPlazosInvalidacion {
  documentos: Array<any>
}

const AvisoPlazosInvalidacion = ({documentos}: PropsAvisoPlazosInvalidacion) => {
  const hoy = new Date()

  if (!documentos || documentos.length === 0) return null

  return (
    <>
      <ul style={{margin: '4px 0 0', paddingLeft: '18px'}}>
        {documentos.map((documento: any, indice: number) => {
          const identificacion = documento?.DetallesDTE?.identificacion
          const tipoDte = identificacion?.tipoDte
          const fechaGeneracion = fechaDesdeTexto(identificacion?.fecEmi)
          const plazo = calcularPlazoDeTransmision(tipoDte, fechaGeneracion, hoy)

          return (
            <li key={identificacion?.numeroControl ?? indice} style={{marginBottom: '10px'}}>
              <span>{identificacion?.numeroControl ?? 'Documento sin número de control'}</span>
              <span style={ESTILO_DETALLE}>
                {descripcionFechaDelEvento(tipoDte, fechaGeneracion)}
              </span>
              <span style={plazo.cumple ? ESTILO_DETALLE : ESTILO_VENCIDO}>
                {descripcionPlazoDeTransmision(tipoDte, fechaGeneracion, hoy)}
              </span>
            </li>
          )
        })}
      </ul>
      <span style={ESTILO_DETALLE}>{AVISO_FECHA_BASE_DEL_PLAZO}</span>
      <span style={ESTILO_DETALLE}>{AVISO_PLAZO_TRANSMISION_INFORMATIVO}</span>
    </>
  )
}

export default AvisoPlazosInvalidacion
